import { render } from "./VehicleItemStamps.vue?vue&type=template&id=73b55ed7&scoped=true"
import script from "./VehicleItemStamps.vue?vue&type=script&lang=js"
export * from "./VehicleItemStamps.vue?vue&type=script&lang=js"

import "./VehicleItemStamps.vue?vue&type=style&index=0&id=73b55ed7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73b55ed7"]])

export default __exports__